import { createSlice } from "@reduxjs/toolkit";

export const EvaluatordData = createSlice({
  name: "EvaluatordData",
  initialState: {},
  reducers: {},
});

export const {} = EvaluatordData.actions;

export default EvaluatordData.reducer;
